import { combineLatest, startWith } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  generateId,
  getChildObjects,
  getFormRoot,
} from '@intellio/shared/utils';
import type { FormlyHookFn } from './formly-hook-fn.type';

import * as _ from 'lodash';

export const generateRebateProjectId = (): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const root = getFormRoot(field);

    const objs = getChildObjects(root, 'generateRebateProjectId');

    const icProjectIdObj = _.find(
      objs,
      (obj) => obj.generateRebateProjectId === 'ic_project_id'
    );

    const rebateProjectIdObj = _.find(
      objs,
      (obj) => obj.generateRebateProjectId === 'rebate_project_id'
    );
    combineLatest<[string, string]>([
      field.formControl.valueChanges.pipe(startWith(field.formControl.value)),
      icProjectIdObj.formControl.valueChanges.pipe(
        startWith(icProjectIdObj.formControl.value)
      ),
    ]).subscribe(([rebateTypeVal, icProjectIdVal]) => {
      let rebateType = '';
      switch (rebateTypeVal) {
        case 'Generation':
          rebateType = 'G';
          break;
        case 'PairedStorage':
          rebateType = 'S';
          break;
        case 'BothGenerationAndStorage':
          rebateType = 'GS';
          break;
        case 'StandAloneStorage':
          rebateType = 'SS';
          break;
      }

      // Format: IC Project ID-rebateType-random hash
      if (
        rebateTypeVal !== null &&
        rebateTypeVal !== undefined &&
        icProjectIdVal !== null &&
        icProjectIdVal !== undefined &&
        icProjectIdVal !== 'null' &&
        rebateTypeVal !== 'null' &&
        rebateTypeVal.length > 0 &&
        icProjectIdVal.length > 0
      ) {
        rebateProjectIdObj.formControl.setValue(
          `${icProjectIdVal}-${rebateType}-${generateId(6)}`
        );
      }
    });
  };
};
